import { MutationOptions } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import { patchBodyPartTwoVehicleInformationFunction } from '@/modules/adjusterReportModules/Insurer-information/queries/patchBodyPartTwoVehicleInformation/patchBodyPartTwoVehicleInformationFunction';
import { PatchBodyPartTwoVehicleInformationType } from '@/modules/adjusterReportModules/Insurer-information/queries/patchBodyPartTwoVehicleInformation/patchBodyPartTwoVehicleInformation.type';

export const patchBodyPartTwoVehicleInformationOption = (): MutationOptions<
  AxiosResponse<any, any>,
  Error,
  PatchBodyPartTwoVehicleInformationType
> => ({
  mutationKey: ['patch-body-part_two-vehicle-information'],
  mutationFn: ({ id, data }: PatchBodyPartTwoVehicleInformationType) =>
    patchBodyPartTwoVehicleInformationFunction({ data, id }),
});
